module.exports = new __parcel__URL__("ALARM-Partner.569bcb9b.png").toString();